export interface Genre {
  slug: string;
  label: string;
  desc: string;
  icon: string;
}

export const genres: Genre[] = [
  { slug: "action", label: "动作", desc: "追逐、对抗与热血，让肾上腺素一路飙升", icon: "ri-fire-line" },
  { slug: "romance", label: "爱情", desc: "关于靠近、等待与心动瞬间的温柔叙事", icon: "ri-heart-3-line" },
  { slug: "comedy", label: "喜剧", desc: "轻松解压，用笑声治愈每一个疲惫的夜晚", icon: "ri-emotion-happy-line" },
  { slug: "sci-fi", label: "科幻", desc: "想象力构筑的未来世界与宇宙远征", icon: "ri-rocket-2-line" },
  { slug: "horror", label: "恐怖", desc: "悬疑与未知交织，紧张感持续到底", icon: "ri-ghost-2-line" },
  { slug: "animation", label: "动画", desc: "天马行空的画面与适合全家的暖心故事", icon: "ri-magic-line" },
  { slug: "mystery", label: "悬疑", desc: "层层反转的谜题与扣人心弦的真相追寻", icon: "ri-search-eye-line" },
  { slug: "drama", label: "剧情", desc: "聚焦现实与人心，细腻而深刻的情感刻画", icon: "ri-book-open-line" },
  { slug: "adventure", label: "冒险", desc: "从荒原到云端，踏上未知土地的旅程", icon: "ri-compass-3-line" },
];